import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Button } from '../components/ui/Button';
import { CheckCircle, Upload, ArrowRight, ArrowLeft } from 'lucide-react';
export function ApplyPage() {
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      setIsSubmitting(true);
      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);
        setIsSuccess(true);
      }, 2000);
    }
  };
  if (isSuccess) {
    return <div className="pt-20 min-h-screen bg-[#faf8f5] flex items-center justify-center p-4" data-id="element-378">
        <Card className="max-w-md w-full text-center p-8" data-id="element-379">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-380">
            <CheckCircle className="h-10 w-10 text-green-600" data-id="element-381" />
          </div>
          <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4" data-id="element-382">
            Application Submitted!
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-383">
            Thank you for applying. Our team will review your details and
            contact you within 24 hours.
          </p>
          <Button onClick={() => window.location.href = '/'} fullWidth data-id="element-384">
            Return Home
          </Button>
        </Card>
      </div>;
  }
  return <div className="pt-20 min-h-screen bg-[#faf8f5] py-12" data-id="element-385">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-386">
        <div className="text-center mb-12" data-id="element-387">
          <h1 className="text-3xl font-bold text-[#1e3a5f] mb-4" data-id="element-388">
            Start Your Application
          </h1>
          <p className="text-gray-600" data-id="element-389">
            Complete the form below to begin your journey.
          </p>
        </div>

        {/* Progress Steps */}
        <div className="mb-8" data-id="element-390">
          <div className="flex items-center justify-between relative" data-id="element-391">
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-1 bg-gray-200 -z-10" data-id="element-392"></div>
            <div className={`absolute left-0 top-1/2 transform -translate-y-1/2 h-1 bg-[#f59e0b] -z-10 transition-all duration-300`} style={{
            width: `${(step - 1) / 2 * 100}%`
          }} data-id="element-393"></div>

            {[1, 2, 3].map(s => <div key={s} className={`flex flex-col items-center bg-[#faf8f5] px-2`} data-id="element-394">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-colors duration-300 ${step >= s ? 'bg-[#1e3a5f] text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-395">
                  {s}
                </div>
                <span className="text-xs mt-2 font-medium text-gray-600" data-id="element-396">
                  {s === 1 ? 'Personal Info' : s === 2 ? 'Preferences' : 'Documents'}
                </span>
              </div>)}
          </div>
        </div>

        <Card className="p-8" data-id="element-397">
          <form onSubmit={handleSubmit} data-id="element-398">
            {step === 1 && <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-399">
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-6" data-id="element-400">
                  Personal Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-401">
                  <Input label="First Name" placeholder="John" required data-id="element-402" />
                  <Input label="Last Name" placeholder="Doe" required data-id="element-403" />
                </div>
                <Input label="Email Address" type="email" placeholder="john@example.com" required data-id="element-404" />
                <Input label="Phone Number" type="tel" placeholder="+1 (555) 000-0000" required data-id="element-405" />
                <Input label="Date of Birth" type="date" required data-id="element-406" />
              </motion.div>}

            {step === 2 && <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-407">
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-6" data-id="element-408">
                  Program Preferences
                </h2>
                <Select label="Preferred Country" options={[{
              value: 'uk',
              label: 'United Kingdom'
            }, {
              value: 'usa',
              label: 'USA'
            }, {
              value: 'canada',
              label: 'Canada'
            }, {
              value: 'australia',
              label: 'Australia'
            }, {
              value: 'germany',
              label: 'Germany'
            }]} required data-id="element-409" />
                <Select label="Study Level" options={[{
              value: 'undergrad',
              label: 'Undergraduate'
            }, {
              value: 'postgrad',
              label: 'Postgraduate'
            }, {
              value: 'diploma',
              label: 'Diploma/Certificate'
            }]} required data-id="element-410" />
                <Input label="Intended Course" placeholder="e.g. Computer Science" required data-id="element-411" />
                <Select label="Highest Qualification" options={[{
              value: 'highschool',
              label: 'High School'
            }, {
              value: 'bachelors',
              label: "Bachelor's Degree"
            }, {
              value: 'masters',
              label: "Master's Degree"
            }]} required data-id="element-412" />
              </motion.div>}

            {step === 3 && <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-413">
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-6" data-id="element-414">
                  Documents & Consent
                </h2>

                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-415">
                  <Upload className="h-10 w-10 text-gray-400 mx-auto mb-4" data-id="element-416" />
                  <p className="text-sm text-gray-600 font-medium" data-id="element-417">
                    Click to upload documents
                  </p>
                  <p className="text-xs text-gray-400 mt-1" data-id="element-418">
                    PDF, JPG up to 5MB (Transcripts, CV, Passport)
                  </p>
                </div>

                <div className="flex items-start space-x-3 pt-4" data-id="element-419">
                  <input type="checkbox" id="consent" className="mt-1 h-4 w-4 text-[#1e3a5f] rounded border-gray-300 focus:ring-[#1e3a5f]" required data-id="element-420" />
                  <label htmlFor="consent" className="text-sm text-gray-600" data-id="element-421">
                    I agree to the processing of my personal data for the
                    purpose of my application. I understand that Study Board
                    will contact me regarding my application.
                  </label>
                </div>
              </motion.div>}

            <div className="flex justify-between mt-8 pt-6 border-t border-gray-100" data-id="element-422">
              {step > 1 ? <Button type="button" variant="ghost" onClick={() => setStep(step - 1)} data-id="element-423">
                  <ArrowLeft className="h-4 w-4 mr-2" data-id="element-424" /> Back
                </Button> : <div data-id="element-425"></div>}

              <Button type="submit" isLoading={isSubmitting} variant="primary" data-id="element-426">
                {step === 3 ? 'Submit Application' : 'Next Step'}
                {step < 3 && <ArrowRight className="h-4 w-4 ml-2" data-id="element-427" />}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>;
}